export const ThreeHourForecast = 
{
  "cod": "200",
  "message": 0,
  "cnt": 6,
  "list": [
    {
      "dt": 1733497200,
      "dt_txt": "2024-12-06 00:00:00",
      "main": {
        "temprature": 282.22,
        "temprature_feels_like": 281.06,
        "temprature_min": 281.53,
        "temprature_max": 282.22,
        "temprature_unit": "K",
        "pressure": 1018,
        "humidity": 68
      },
      "weather": [
        {
          "id": 802,
          "main": "Clouds",
          "description": "scattered clouds",
          "icon": "03d"
        }
      ],
      "wind": {
        "speed": 2.25,
        "degrees": 216
      },
      "probability_of_precipitation": 0
    },
    {
      "dt": 1733508000,
      "dt_txt": "2024-12-06 03:00:00",
      "main": {
        "temprature": 281.10,
        "temprature_feels_like": 279.88,
        "temprature_min": 280.90,
        "temprature_max": 281.30,
        "temprature_unit": "K",
        "pressure": 1015,
        "humidity": 72
      },
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "wind": {
        "speed": 1.8,
        "degrees": 190
      },
      "probability_of_precipitation": 0
    },
    {
      "dt": 1733518800,
      "dt_txt": "2024-12-06 06:00:00",
      "main": {
        "temprature": 280.30,
        "temprature_feels_like": 278.80,
        "temprature_min": 280.00,
        "temprature_max": 280.50,
        "temprature_unit": "K",
        "pressure": 1013,
        "humidity": 76
      },
      "weather": [
        {
          "id": 801,
          "main": "Clouds",
          "description": "few clouds",
          "icon": "02n"
        }
      ],
      "wind": {
        "speed": 1.5,
        "degrees": 180
      },
      "probability_of_precipitation": 10
    },
    {
      "dt": 1733529600,
      "dt_txt": "2024-12-06 09:00:00",
      "main": {
        "temprature": 281.50,
        "temprature_feels_like": 280.10,
        "temprature_min": 281.30,
        "temprature_max": 281.70,
        "temprature_unit": "K",
        "pressure": 1012,
        "humidity": 70
      },
      "weather": [
        {
          "id": 500,
          "main": "Rain",
          "description": "light rain",
          "icon": "10n"
        }
      ],
      "wind": {
        "speed": 2.0,
        "degrees": 170
      },
      "probability_of_precipitation": 50
    },
    {
      "dt": 1733540400,
      "dt_txt": "2024-12-06 12:00:00",
      "main": {
        "temprature": 284.00,
        "temprature_feels_like": 283.00,
        "temprature_min": 283.80,
        "temprature_max": 284.20,
        "temprature_unit": "K",
        "pressure": 1010,
        "humidity": 65
      },
      "weather": [
        {
          "id": 803,
          "main": "Clouds",
          "description": "broken clouds",
          "icon": "04d"
        }
      ],
      "wind": {
        "speed": 3.0,
        "degrees": 160
      },
      "probability_of_precipitation": 20
    },
    {
      "dt": 1733551200,
      "dt_txt": "2024-12-06 15:00:00",
      "main": {
        "temprature": 285.50,
        "temprature_feels_like": 284.20,
        "temprature_min": 285.30,
        "temprature_max": 285.70,
        "temprature_unit": "K",
        "pressure": 1009,
        "humidity": 60
      },
      "weather": [
        {
          "id": 804,
          "main": "Clouds",
          "description": "overcast clouds",
          "icon": "04d"
        }
      ],
      "wind": {
        "speed": 3.5,
        "degrees": 150
      },
      "probability_of_precipitation": 30
    }
  ],
  "city": {
    "id": 5128581,
    "name": "New York",
    "coord": {
      "lat": 40.7143,
      "lon": -74.006
    },
    "country": "US",
    "population": 8175133,
    "timezone": -18000,
    "sunrise": 1733458800,
    "sunset": 1733492400
  }
}

